module.exports = __webpack_public_path__ + "static/media/0010_LES_MURS_POSE_CHEVRON.1e0d43c3.webp";